import LicenseFileLocations from '../../fragments/LicenseFileLocations'
import { Page } from '../../types'

type CopyCloudLicenseFileProps = {
    isContainer: boolean,
    os: string
}

const render = ({ isContainer: container, os }: CopyCloudLicenseFileProps) => 
    <p>In a previous step, you have downloaded your Instant Cloud license
    file. <LicenseFileLocations description='cloud license file' isContainer={container} os={os}/>
    </p>

const CopyCloudLicenseFile : Page<CopyCloudLicenseFileProps> = { key: 'copy-cloud-license', title: 'Copy Instant Cloud license', render }

export default CopyCloudLicenseFile